var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import StyledIcon from './StyledIcon';

var QBCheckmarkIcon = function QBCheckmarkIcon(props) {
  return React.createElement(
    StyledIcon,
    _extends({}, props, { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 12 11' }),
    React.createElement(
      'g',
      { strokeWidth: '1', fillRule: 'evenodd' },
      React.createElement(
        'g',
        { transform: 'translate(-4.000000, -5.000000)' },
        React.createElement('path', { d: 'M8.93333333,15.1247438 C8.74133333,15.3393711 8.548,15.3393711 8.356,15.1247438 L8.01066667,14.7372223 L4,10.6101186 L5.616,8.61140207 L8.55866667,11.6743122 L14.2693333,5 L16,6.87053636 L8.93333333,15.1247438 Z' })
      )
    )
  );
};
export default QBCheckmarkIcon;